import React, { useState, useEffect } from 'react'
import localization from '../utils/localization'
import FormInput from './FormInput'
import { Button, Box, Typography, Stack, Paper, IconButton } from '@mui/material'

function ExtraForm(props) {
  const [extra, setExtra] = useState(props.extra || {})
  const [keyName, setKeyName] = useState('')
  const [keyNameErr, setKeyNameErr] = useState('')

  useEffect(() => {
    props.onChange(extra)
  }, [extra])

  return (
    <Stack spacing={2}>
      <Typography variant="caption" sx={{ color: '#94A3B8', fontWeight: 800, textTransform: 'uppercase', px: 1 }}>
        {localization.strings.addExtraKeys}
      </Typography>

      {typeof extra === 'object' && Object.keys(extra).map((key) => (
        <Paper
          key={key}
          elevation={0}
          sx={{
            p: 2,
            borderRadius: '16px',
            border: '1px solid rgba(0,0,0,0.04)',
            backgroundColor: '#fff',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            gap: 2,
          }}
        >
          <Box sx={{ minWidth: '80px', pt: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 700, color: '#64748B' }}>
              {key}
            </Typography>
          </Box>
          
          <Box sx={{ flex: 1 }}>
            <FormInput
              wrapContent={true}
              multiline={true}
              minRows={1}
              value={extra[key]}
              size="small"
              placeholder={localization.strings.inputValueHint}
              onChange={(event) => {
                let newExtra = Object.assign({}, extra)
                newExtra[key] = event.target.value
                setExtra(newExtra)
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '12px',
                  backgroundColor: 'rgba(0,0,0,0.02)',
                }
              }}
            />
          </Box>

          <IconButton
            size="small"
            onClick={() => {
              let newExtra = Object.assign({}, extra)
              delete newExtra[key]
              setExtra(newExtra)
            }}
            sx={{
              backgroundColor: 'rgba(239, 68, 68, 0.08)',
              color: '#EF4444',
              borderRadius: '10px',
              mt: 0.5,
              '&:hover': { backgroundColor: 'rgba(239, 68, 68, 0.15)' }
            }}
          >
            <i className="iconfont icon-close" style={{ fontSize: '1rem' }}></i>
          </IconButton>
        </Paper>
      ))}

      <Box
        sx={{
          p: 2,
          borderRadius: '16px',
          border: '1px dashed rgba(0,0,0,0.12)',
          backgroundColor: 'rgba(0,0,0,0.01)',
        }}
      >
        <Stack direction="row" spacing={2} alignItems="flex-start">
          <Box sx={{ flex: 1 }}>
            <FormInput
              label={localization.strings.keyName}
              value={keyName}
              size="small"
              placeholder={localization.strings.inputKeyNameHint}
              error={keyNameErr}
              onChange={(event) => {
                setKeyNameErr('')
                setKeyName(event.target.value)
              }}
            />
          </Box>
          <Button
            variant="contained"
            onClick={() => {
              if (keyName === '') {
                setKeyNameErr(localization.strings.required)
                return
              } else if (keyName in extra) {
                setKeyNameErr(localization.strings.exists)
                return
              }
              let newExtra = Object.assign({}, extra)
              newExtra[keyName] = ''
              setExtra(newExtra)
              setKeyName('')
            }}
            sx={{
              height: '2.8rem',
              borderRadius: '10px',
              backgroundColor: '#6366F1',
              textTransform: 'none',
              fontWeight: 700,
              boxShadow: '0 4px 12px rgba(99, 102, 241, 0.2)',
              '&:hover': { backgroundColor: '#4F46E5' },
            }}
          >
            {localization.strings.addKey}
          </Button>
        </Stack>
      </Box>
    </Stack>
  )
}

export default ExtraForm
